import TagInput from "components/TagInput"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import Select from "react-select"
import * as Yup from "yup"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap"
import { UPDATE_PVS_REGISTRATION_RESET } from "../../../redux/types/pvs"
import { useDispatch, useSelector } from "react-redux"
import {
  fetchPvsKeyword,
  fetchPvsSubcategory,
  updatePvsRegistration,
} from "../../../redux/actions/pvs"
import ErrorPopup from "components/ErrorPopup"
import { toast } from "react-toastify"
import { getProductList } from "../../../redux/actions/user"

const Step4 = props => {
  const dispatch = useDispatch()
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [keywordsOptions, setKeywordsOptions] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([])
  const [subcategoryOptions, setSubcategoryOptions] = useState([])
  const [productOptions, setProductOptions] = useState([])

  const keywordList = useSelector(state => state.pvs.keywordList)
  const categoryList = useSelector(state => state.pvs.categoryList)
  const subcategoryList = useSelector(state => state.pvs.subcategoryList)
  const products = useSelector(state => state.user.products)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const updatePvsRegistrationScreen = useSelector(
    state => state.screens.pvs.updatePvsRegistration
  )

  useEffect(() => {
    dispatch(fetchPvsKeyword({ offset: 1 }))
  }, [])

  useEffect(() => {
    if (updatePvsRegistrationScreen.success && props.activeTab === 4) {
      // toast.success(updatePvsRegistrationScreen.message)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
      props.toggleTab(props.activeTab + 1)
    }
    if (updatePvsRegistrationScreen.error && props.activeTab === 4) {
      toast.error(updatePvsRegistrationScreen.error)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
    }
  }, [updatePvsRegistrationScreen])

  useEffect(() => {
    if (categoryList && categoryList.length > 0) {

      let tempCategoryOption = []
      categoryList.map(option => {
        tempCategoryOption.push({
          label: option.category,
          value: option.pvs_cat_id,
          encId: option.enc_pvs_cat_id,
        })
      })
      setCategoryOptions(tempCategoryOption)
    }
  }, [categoryList])

  useEffect(() => {
    if (keywordList && keywordList.length > 0) {

      let tempKeywordOption = []
      keywordList.map(option => {
        tempKeywordOption.push({
          label: option.keyword,
          value: option.pvs_key_id,
          encId: option.enc_pvs_key_id,
        })
      })
      setKeywordsOptions(tempKeywordOption)
    }
  }, [keywordList])

  useEffect(() => {
    if (subcategoryList && subcategoryList.length > 0) {

      let tempSubcategoryOption = []
      subcategoryList.map(option => {
        tempSubcategoryOption.push({
          label: option.subcategory,
          value: option.pvs_subcat_id,
          encId: option.enc_pvs_subcat_id,
        })
      })
      setSubcategoryOptions(tempSubcategoryOption)
    }
  }, [subcategoryList])

  useEffect(() => {
    if (products && products.length > 0) {

      let tempProductOption = []
      products.map(option => {
        tempProductOption.push({
          label: option.product_label,
          value: option.product_id,
          encId: option.enc_product_id,
        })
      })
      setProductOptions(tempProductOption)
    }
  }, [products])

  const step4Formik = useFormik({
    initialValues: {
      brandName: "",
      branches: [],
      keywords: [],
      newKeywords: [],
      category: "",
      subCategory: [],
      website: "",
      instagram: "",
      facebook: "",
      google: "",
      product: [],
      otherProducts: [],
      linkedin: "",
      hasofflinebussiness: false,
    },
    validationSchema: Yup.object({
      brandName: Yup.string().required("Brand Name is required"),
      // branches: Yup.array().min(1, "Branches is required"),
      keywords: Yup.array()
        // .min(1, "Keywords is required")
        .test(
          "keywords-max",
          "Total selection of Keywords + Other Keywords cannot be more than 5",
          function (value) {
            const newKeywords = this.parent.newKeywords || []
            return (value || []).length + newKeywords.length <= 5
          }
        ),
      newKeywords: Yup.array(),
      // .test(
      //   "newKeywords-max",
      //   "Total keywords (selected + other) cannot exceed 5",
      //   function (value) {
      //     const keywords = this.parent.keywords || []
      //     return keywords.length + (value || []).length <= 5
      //   }
      // ),
      category: Yup.object().required("Category is required"),
      subCategory: Yup.array().min(1, "Subcategory is required"),
      website: Yup.string(),
      instagram: Yup.string(),
      facebook: Yup.string(),
      google: Yup.string(),
      // product: Yup.array().min(1, "Product is required"),
      otherProducts: Yup.array(),
      linkedin: Yup.string(),
    }),
    onSubmit: values => {
      let keywordIds = values.keywords.map(keyword => keyword.value)
      let productIds = values.product.map(product => product.value)
      let subcategoryIds = values.subCategory.map(
        subCategory => subCategory.value
      )
      let requestData = {
        step: 4,
        pvs_entry_id: pvsFormData.pvs_entry_id,
        data: {
          brand_name: values.brandName,
          branches: values.branches.join(", "),
          keywords: keywordIds,
          new_keywords: values.newKeywords.join(", "),
          categories: [values.category.value],
          new_categories: "",
          subcategories: subcategoryIds,
          new_subcategories: "",
          products: productIds,
          new_products: values.otherProducts.join(", "),
          social_fb_link: values.facebook,
          social_insta_link: values.instagram,
          social_linkedin_link: values.linkedin,
          social_gplus_link: values.google,
          social_website_link: values.website,
          is_offline_store: values.hasofflinebussiness,
        },
      }
      dispatch(updatePvsRegistration(requestData))
    },
  })  

  useEffect(() => {
    dispatch(fetchPvsKeyword({ offset: 1 }))
    if (pvsFormData) {
      let formData = {
        brandName: pvsFormData.brand_name,
        branches: pvsFormData.branches ? pvsFormData.branches.split(",") : [],
        keywords: [],
        newKeywords: [],
        category: categoryOptions.find(
          val => val.value === Number(pvsFormData.categories)
        ),
        subCategory: [],
        website: pvsFormData.social_website_link || "",
        instagram: pvsFormData.social_insta_link || "",
        facebook: pvsFormData.social_fb_link || "",
        google: pvsFormData.social_gplus_link || "",
        product: [],
        otherProducts: [],
        linkedin: pvsFormData.social_linkedin_link || "",
        hasofflinebussiness: pvsFormData.is_offline_store || false,
      }

      step4Formik.setValues(formData)
    }
  }, [pvsFormData])

  useEffect(() => {
    if (pvsFormData && pvsFormData.keywords && keywordsOptions) {
      let keywordArr = pvsFormData.keywords.split(",")

      let selectedKeywords = []

      keywordArr.map(keyword => {
        const foundKeyword = keywordsOptions.find(
          option => option.value === Number(keyword)
        )
        if (foundKeyword) {
          selectedKeywords.push(foundKeyword)
        }
      })
      step4Formik.setFieldValue("keywords", selectedKeywords)
    }

    if (pvsFormData && pvsFormData.categories && categoryOptions) {
      step4Formik.setFieldValue(
        "category",
        categoryOptions.find(
          val => val.value === Number(pvsFormData.categories)
        )
      )
    }

    if (pvsFormData && pvsFormData.subcategories && subcategoryOptions) {
      let subcategoryArr = pvsFormData.subcategories.split(",")
      let selectedSubCategories = []

      subcategoryArr.map(subcategory => {

        const foundSubCategory = subcategoryOptions.find(
          val => val.value === Number(subcategory)
        )
        if (foundSubCategory) {
          selectedSubCategories.push(foundSubCategory)
        }
      })
      step4Formik.setFieldValue("subCategory", selectedSubCategories)
    }

    // if (pvsFormData && pvsFormData.products && productOptions) {
    //   let productArr = pvsFormData.products.split(",")

    //   let selectedProducts = []

    // productArr.map(product => {
    //   const foundProduct = productOptions.find(val => {
    //     return val.value === Number(product)
    //   })
    //   if (foundProduct) {
    //     selectedProducts.push(foundProduct)
    //   }
    // })

    // step4Formik.setFieldValue("product", selectedProducts)
    // }
  }, [
    pvsFormData,
    keywordsOptions,
    categoryOptions,
    subcategoryOptions,
    // productOptions,
  ])

  useEffect(() => {
    if (step4Formik.values.category) {
      dispatch(
        fetchPvsSubcategory({
          enc_pvs_cat_id: step4Formik.values.category.encId,
        })
      )
      // dispatch(
      //   getProductList({
      //     enc_pvs_cat_id: step4Formik.values.category.encId,
      //   })
      // )
    }
  }, [step4Formik.values.category])

  useEffect(() => {
    if (step4Formik.isSubmitting && step4Formik.errors) {
      step4Formik.setSubmitting(false)
      if (Object.keys(step4Formik.errors).length > 0) {
        let message = (
          <div>
            <ul className="mb-0 ps-3">
              {Object.keys(step4Formik.errors).map(key => (
                <li key={key} className="mb-3">
                  {step4Formik.errors[key]}
                </li>
              ))}
            </ul>
          </div>
        )
        setIsErrorMessage(message)
        setIsErrorOpen(true)
      }
    }
  }, [step4Formik])

  return (
    <div className="step4wrapper">
      <Form onSubmit={step4Formik.handleSubmit}>
        <Card className="shadow-sm">
          <CardBody>
            <div className="form-check">
              <Input
                id="offlineStore"
                name="offlineStore"
                type="checkbox"
                className="form-check-input"
                checked={step4Formik.values.hasofflinebussiness}
                onChange={() =>
                  step4Formik.setFieldValue(
                    "hasofflinebussiness",
                    !step4Formik.values.hasofflinebussiness
                  )
                }
              />
              <Label htmlFor="checkinput">
                I have an offline store for my business
              </Label>
            </div>
            <div className="step4-common-padding">
              <h4 className="nom-title">Directory Details</h4>
              {/* Directory Details */}
              <Row className="g-4">
                <Col md={6}>
                  <Label htmlFor="txtBrandName" className="form-label">
                    Brand Name <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    id="txtBrandName"
                    name="brandName"
                    placeholder="Brand Name"
                    type="text"
                    value={step4Formik.values.brandName}
                    onChange={step4Formik.handleChange}
                  />
                  {step4Formik.touched.brandName &&
                    step4Formik.errors.brandName && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.brandName}
                      </div>
                    )}
                </Col>
                <Col md={6}>
                  <TagInput
                    title="Branches"
                    // star="*"
                    classNameTag="step-taginp"
                    tags={step4Formik.values.branches}
                    onChange={val => step4Formik.setFieldValue("branches", val)}
                    buttonTitle="Add"
                    onAddClick={(value, allTags) => {
                      step4Formik.setFieldValue("branches", allTags)
                    }}
                  />
                  {step4Formik.touched.branches &&
                    step4Formik.errors.branches && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.branches}
                      </div>
                    )}
                </Col>
              </Row>
            </div>
            {/* Select keywords */}
            <div className="step4-common-padding">
              <h4 className="nom-title">Select Keywords</h4>
              <Row className="g-1">
                <Col md={12}>
                  <Label htmlFor="txtBrandName" className="form-label">
                    Select Keywords from the dropdown{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Select
                    id="products"
                    name="Keywords"
                    options={keywordsOptions}
                    isMulti
                    classNamePrefix="select"
                    placeholder="Search the keywords..."
                    value={step4Formik.values.keywords}
                    onChange={val => step4Formik.setFieldValue("keywords", val)}
                  />
                  {/* {step4Formik.touched.keywords &&
                    step4Formik.errors.keywords && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.keywords}
                      </div>
                    )} */}
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-4">
                  <TagInput
                    title="Other Keywords"
                    // star="*"
                    classNameTag="step-taginp"
                    tags={step4Formik.values.newKeywords}
                    onChange={val =>
                      step4Formik.setFieldValue("newKeywords", val)
                    }
                    buttonTitle="Add"
                    onAddClick={(value, allTags) => {
                      step4Formik.setFieldValue("newKeywords", allTags)
                    }}
                  />
                  {/* {step4Formik.touched.newKeywords &&
                    step4Formik.errors.newKeywords && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.newKeywords}
                      </div>
                    )} */}
                </Col>
              </Row>
            </div>
            {/* Select Category */}
            <div className="step4-common-padding">
              <h4 className="nom-title">Select Category</h4>
              <Row>
                <Col md={12}>
                  <Label htmlFor="ddlCategory" className="form-label">
                    Category <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Select
                    id="products"
                    name="product"
                    options={categoryOptions}
                    classNamePrefix="select"
                    placeholder="Search the category..."
                    value={step4Formik.values.category}
                    onChange={val => {
                      step4Formik.setFieldValue("category", val)
                      step4Formik.setFieldValue("subCategory", [])
                    }}
                  />
                  {step4Formik.touched.category &&
                    step4Formik.errors.category && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.category}
                      </div>
                    )}
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-4">
                  <Label htmlFor="ddlSubCategory" className="form-label">
                    Subcategory <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Select
                    id="subcategory"
                    name="subcategory"
                    isMulti
                    options={subcategoryOptions}
                    classNamePrefix="select"
                    placeholder="Search the subcategory..."
                    value={step4Formik.values.subCategory}
                    onChange={val =>
                      step4Formik.setFieldValue("subCategory", val)
                    }
                  />
                  {step4Formik.touched.subCategory &&
                    step4Formik.errors.subCategory && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.subCategory}
                      </div>
                    )}
                </Col>
              </Row>
            </div>
            {/* <div className="step4-common-padding">
              <h4 className="nom-title">Product Details</h4>
              <Row>
                <Col xs={12}>
                  <Label htmlFor="ddlProducts" className="form-label">
                    Select Product from the dropdown{" "}
                    {/* <span className="text-danger">*</span> *
                  </Label>
                  <Select
                    id="products"
                    name="product"
                    isMulti
                    options={productOptions}
                    classNamePrefix="select"
                    placeholder="Search the product..."
                    value={step4Formik.values.product}
                    onChange={val => step4Formik.setFieldValue("product", val)}
                  />
                  {step4Formik.touched.product &&
                    step4Formik.errors.product && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.product}
                      </div>
                    )}
                </Col>
                <Col xs={12} className="mt-4">
                  <Label htmlFor="txtOtherProducts" className="form-label">
                    Other Products
                  </Label>
                  <TagInput
                    tags={step4Formik.values.otherProducts}
                    title="If you don’t find your product in the list above, please type it here to add it."
                    onChange={val =>
                      step4Formik.setFieldValue("otherProducts", val)
                    }
                    buttonTitle="Add"
                    onAddClick={(value, allTags) => {
                      step4Formik.setFieldValue("otherProducts", allTags)
                    }}
                  />
                  {step4Formik.touched.otherProducts &&
                    step4Formik.errors.otherProducts && (
                      <div className="text-danger small mt-1">
                        {step4Formik.errors.otherProducts}
                      </div>
                    )}
                </Col>
              </Row>
            </div> */}
            {/* Social Connects */}
            <div className="step4-common-padding">
              <h4 className="nom-title">Social Connects</h4>
              <Row className="g-4">
                <Col md={6}>
                  <Label htmlFor="txtWebsite" className="form-label">
                    🌐 Website URL
                  </Label>
                  <Input
                    id="txtWebsite"
                    name="website"
                    type="text"
                    value={step4Formik.values.website}
                    onChange={step4Formik.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <Label htmlFor="txtInstagram" className="form-label">
                    📸 Instagram URL
                  </Label>
                  <Input
                    id="txtInstagram"
                    name="instagram"
                    type="text"
                    value={step4Formik.values.instagram}
                    onChange={step4Formik.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <Label htmlFor="txtFacebook" className="form-label">
                    📘 Facebook URL
                  </Label>
                  <Input
                    id="txtFacebook"
                    name="facebook"
                    type="text"
                    value={step4Formik.values.facebook}
                    onChange={step4Formik.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <Label htmlFor="txtGoogle" className="form-label">
                    ▶️ Google+ URL
                  </Label>
                  <Input
                    id="txtGoogle"
                    name="google"
                    type="text"
                    value={step4Formik.values.google}
                    onChange={step4Formik.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <Label htmlFor="txtLinkedIn" className="form-label">
                    💼 LinkedIn URL
                  </Label>
                  <Input
                    id="txtLinkedIn"
                    name="linkedin"
                    type="text"
                    value={step4Formik.values.linkedin}
                    onChange={step4Formik.handleChange}
                  />
                </Col>
              </Row>
            </div>
            <div className="pvs-reg-actions actions">
              <div className="btngroup-pvs">
                <div>
                  <Button
                    color="primary"
                    size="md"
                    disabled={props.activeTab === 1}
                    onClick={() => {
                      props.toggleTab(props.activeTab - 1)
                    }}
                  >
                    <i className="dripicons-arrow-thin-left"></i>
                    <span>Previous</span>
                  </Button>
                </div>
                <div>
                  <Button color="primary" size="md" type="submit">
                    <span>Save & Continue</span>
                    <i className="dripicons-arrow-thin-right"></i>
                  </Button>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Form>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
    </div>
  )
}

export default Step4
